import React, { useEffect, useState } from "react";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import SinglePage from "../PdfViewer/PdfViewer";
import { Button, IconButton, Snackbar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MerText from "../MerComponents/MerText";
import MerEmail from "../MerComponents/MerEmail";
import MerInteger from "../MerComponents/MerInteger";
import MerDropDown from "../MerComponents/MerDropDown";
import MerNone from "../MerComponents/MerNone";
import MerRadio from "../MerComponents/MerRadio";
import MerDate from "../MerComponents/MerDate";
import MerTime from "../MerComponents/MerTime";
import MerCheckbox from "../MerComponents/MerCheckbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import "./MER.css";
import { URL } from "../../constants/constant";
import {forwardAnalyticsEvent} from "../../util/sendAnalyticsEvent"

const Component = ({
  row,
  setOpenSnackBar,
  setMessage,
  abled,
  merData,
  setMandatoryLeft,
}) => {
  const handleChange = (id, updatedValue, questionId) => {
    if (merData[id - 1]["mandatory"] && updatedValue && !merData[id - 1]["value"]) {
      setMandatoryLeft(prevVal => prevVal - 1);
    }
    if (merData[id - 1]["mandatory"] && !updatedValue && merData[id - 1]["value"]) {
      setMandatoryLeft(prevVal => prevVal + 1);
    }
    merData[id-1]["value"] = updatedValue;
  };

  switch (row.question_type) {
    case "text":
      return <MerText info={row} handleChange={handleChange} abled={abled} />;
    case "email":
      return <MerEmail info={row} handleChange={handleChange} abled={abled} />;
    case "integer":
      return (
        <MerInteger
          info={row}
          handleChange={handleChange}
          abled={abled}
          setOpen={setOpenSnackBar}
          setMessage={setMessage}
        />
      );
    case "float":
      return (
        <MerInteger info={row} handleChange={handleChange} abled={abled} />
      );
    case "mobile_no":
      return (
        <MerInteger info={row} handleChange={handleChange} abled={abled} />
      );
    case "drop_down":
      return (
        <MerDropDown info={row} handleChange={handleChange} abled={abled} />
      );
    case "radio_button":
      return <MerRadio info={row} handleChange={handleChange} abled={abled} />;
    case "checkbox":
      return (
        <MerCheckbox info={row} handleChange={handleChange} abled={abled} />
      );
    case "date":
      return <MerDate info={row} handleChange={handleChange} abled={abled} />;
    case "time":
      return <MerTime info={row} handleChange={handleChange} abled={abled} />;
    case "none":
      return <MerNone info={row} />;
    default:
      return <div></div>;
  }
};

const MER = ({
  toggleMER,
  profile,
  profileName,
  pmId,
  caseId,
  abled,
  setAbled,
  editable,
  loggedInUser,
  setFormFilled,
  formType,
  status,
  repeatCaseCount
}) => {
  const [merData, setMerData] = useState([]);
  const [mandatoryLeft, setMandatoryLeft] = useState(0);
  const [mandatory, setMandatory] = useState(0);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openSnackbar, setOpenSnackBar] = useState(false);
  const [message, setMessage] = useState();
  const [testPage, setTestPage] = useState(1);
  const [preSignedUrl, setPreSignedUrl] = useState(''); 
  //snackbar
  const handleSnackbar = () => {
    setOpenSnackBar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackBar(false);
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleCloseSnackbar}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );
  //fetching mer pdf
  useEffect(() => {
    setPdfLoading(true);
    var data = JSON.stringify({
      request_id: Number(caseId),
      send_URL: 1,
    });

    var config = {
      method: "post",
      url: URL.demystify_url + "caseDetails/fetchMERBase64pdf/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.success) {
          setPreSignedUrl(response.data.preSignedUrl);
        } else {
          setMessage(`Something wrong happened while fetching PDF`);
          handleSnackbar();
        }
        setPdfLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setPdfLoading(false);
      });
  }, []);

  //fetching mer form
  useEffect(() => {
    var data = JSON.stringify({
      profile: profile,
      profile_name: profileName,
      pm_entity_id: pmId,
      form_type: formType,
      caseId: caseId,
    });

    setLoading(true);

    var config = {
      method: "post",
      url: URL.demystify_url + "mer/fetchMERresponse/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        setMerData(response.data.message["MER_questions"]);
        setMandatoryLeft(response.data.message["mandatoryLeft"]);
        setMandatory(response.data.message["totalMandatory"]);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  }, []);

  const [openSaveDialog, setOpenSaveDialog] = useState(false);

  const handleSaveOpen = () => {
    setOpenSaveDialog(true);
  };

  const handleSaveClose = () => {
    setOpenSaveDialog(false);
  };

  const handleSave = () => {
    var data = JSON.stringify({
      profile: profile,
      profile_name: profileName,
      pm_entity_id: pmId,
      form_type: "PPMC",
      caseId: caseId,
      user: loggedInUser,
      MER_questions: merData,
    });

    forwardAnalyticsEvent("MERSaveClicked", { caseId: caseId, currentStatus: status, repeatCaseCount: repeatCaseCount });

    var config = {
      method: "post",
      url: URL.demystify_url + "mer/saveMERresponse",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.success === 1) {
          setMessage(`Response saved successfully`);
          handleSnackbar();
          handleSaveClose();
          setAbled(false);
        } else if (response.data.success === 0) {
          setMessage(response.data.errorMessage);
          handleSnackbar();
          handleSaveClose();
        } else {
          setMessage(`Something went wrong, please try again`);
          handleSnackbar();
          handleSaveClose();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <>
      {pdfLoading ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={pdfLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <div className="grid-container-mer">
          <div className="grid-pdf">
            <div className="split left">
              <SinglePage
                // base64String={base64String}
                reportFileType="application/pdf"
                preSignedUrl = {preSignedUrl}
                testPage={testPage}
                setTestPage={setTestPage}
              />
            </div>
          </div>
          <div className="grid-form split right">
            {loading ? (
              <div className="mer-loader">
                <CircularProgress />
              </div>
            ) : (
              <div className="grid-MER-right"> 
                <Dialog open={openSaveDialog} onClose={handleSaveClose}>
                  <DialogTitle>Save the current details?</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      Are you sure you want to save ?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={handleSaveClose}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={handleSave}
                    >
                      Save
                    </Button>
                  </DialogActions>
                </Dialog>
                <div className="grid-topDiv">
                  <IconButton
                    onClick={() => {
                      setFormFilled(!mandatoryLeft);
                      toggleMER();
                    }}
                  >
                    <ArrowCircleLeftIcon
                      sx={{ fontSize: 40, color: "#4095f7" }}
                    />
                  </IconButton>
                  <h3>MER Form</h3>
                  <p>{`${mandatory - mandatoryLeft} /  ${mandatory}`}</p>
                  <div className="top-btns">
                    <IconButton
                      onClick={() => {
                        setAbled(editable && true);
                      }}
                    >
                      <EditOutlinedIcon color="primary" />
                    </IconButton>
                    <Button
                      variant="outlined"
                      sx={{ height: "fit-content" }}
                      onClick={handleSaveOpen}
                    >
                      Save
                    </Button>
                  </div>
                </div>
                <div className="grid-questions">
                  {merData?.map((row, index) => (
                    <Component
                      key={index}
                      row={row}
                      setOpenSnackBar={setOpenSnackBar}
                      setMessage={setMessage}
                      abled={abled}
                      merData={merData}
                      setMandatoryLeft={setMandatoryLeft}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
          <Snackbar
            open={openSnackbar}
            autoHideDuration={3000}
            onClose={handleCloseSnackbar}
            action={action}
            message={message}
          />
        </div>
      )}
    </>
  );
};

export default MER;
